import { getAccessToken } from '@nexus/supabase';

import { getAuthBackendUrl } from '../config/global';

interface TokenResponse {
  access_token: string;
}

/**
 * Bot-UI `fetchToken` callback for the chat-history view. Returns a Microsoft
 * Graph token (via the `microsoft_contacts` connector) so contact / Teams
 * artifacts can render profile photos, or null when the user hasn't connected
 * Microsoft Contacts (or has no session) — callers fall back to initials.
 *
 * Mirrors apps/ari's getMicrosoftToken endpoint, using ari-cloud's existing
 * Auth0-Bearer pattern (see use-connectors.ts).
 */
export async function fetchGraphToken(): Promise<string | null> {
  const token = await getAccessToken();
  if (!token) return null;

  const res = await fetch(`${getAuthBackendUrl()}/auth/connectors/microsoft_contacts/token`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) return null;

  const data = (await res.json()) as TokenResponse;
  return data.access_token ?? null;
}
